import React from 'react';
import Link from 'next/link';

const ContactFormLeftPanel: React.FC = () => {
  return (
    <div className="hidden lg:block lg:w-1/2 bg-cover bg-center relative" style={{ backgroundColor: "#285CEB" }}>
      <div
        className="absolute inset-0 bg-cover bg-center opacity-30"
        style={{ backgroundImage: "url('/images/circuit_bg.svg')" }}
      />
      <div className="relative z-10 w-full h-full p-[2rem] lg:p-[4rem] flex justify-center items-center overflow-y-auto">
        <div className="w-full h-full max-w-[420px] p-[1.5rem] lg:p-[2.5rem] flex flex-col gap-[2rem] border border-[rgba(255,255,255,0.25)] rounded-2xl">
          <div className="flex justify-start">
            <img src="/images/logo.svg" alt="sixsense logo" className="h-[2.75rem] w-auto" />
          </div>
          <div className="flex flex-col items-start gap-[24px]">
            <h2 className="self-stretch text-white font-ibm-plex text-[28px] font-[600] leading-[1.4]">
              Move a step closer to maximising yield &amp; productivity
            </h2>
            <p className="self-stretch text-white text-[16px] font-ibm-plex font-normal leading-[1.5]">
              Contact us to explore how Sixsense can drive defect reduction, optimize performance,
              and unlock measurable ROI.
            </p>
            <div className="flex flex-col items-start gap-[16px] mt-2">
              <div className="flex items-center gap-3">
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.59375 1.78125C0.25 1.875 0 2.15625 0 2.5C0 10.5312 6.5 17 14.5 17C14.875 17 15.1562 16.7812 15.25 16.4375L16 13.1875C16.0625 12.8438 15.9062 12.4688 15.5625 12.3125L12.0625 10.8125C11.75 10.6875 11.4062 10.7812 11.1875 11.0312L9.625 12.9375C7.1875 11.7812 5.21875 9.78125 4.09375 7.40625L6 5.84375C6.25 5.625 6.34375 5.28125 6.21875 4.96875L4.71875 1.46875C4.5625 1.125 4.1875 0.9375 3.84375 1.03125L0.59375 1.78125Z" fill="white" />
                </svg>
                <Link href="tel:+6594860203" className="text-white text-[1rem] font-ibm-plex font-[400] leading-[150%]">
                  +65 94860203
                </Link>
              </div>
              <div className="flex items-center gap-3">
                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.3125 3.96875C0.1875 3.875 0 3.96875 0 4.125V10.5C0 11.3438 0.6875 12 1.5 12H14.5C15.3438 12 16 11.3438 16 10.5V4.125C16 3.96875 15.8438 3.875 15.7188 3.96875C15 4.53125 14.0938 5.21875 10.9062 7.53125C10.25 8 9.125 9.03125 8 9.03125C6.90625 9.03125 5.75 8 5.125 7.53125C1.9375 5.21875 1.03125 4.53125 0.3125 3.96875ZM8 8C8.75 8.03125 9.78125 7.09375 10.3125 6.71875C14.4688 3.71875 14.7812 3.4375 15.7188 2.6875C15.9062 2.5625 16 2.34375 16 2.09375V1.5C16 0.6875 15.3438 0 14.5 0H1.5C0.6875 0 0 0.6875 0 1.5V2.09375C0 2.34375 0.125 2.5625 0.3125 2.6875C1.25 3.4375 1.5625 3.71875 5.71875 6.71875C6.25 7.09375 7.28125 8.03125 8 8Z" fill="white" />
                </svg>
                <Link href="mailto:demo@sixsense.ai" className="text-white text-[1rem] font-ibm-plex font-[400] leading-[150%]">
                  demo@sixsense.ai
                </Link>
              </div>
              <div className="flex items-center gap-3">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.13375 14H0.23125V4.65292H3.13375V14ZM1.68094 3.37789C0.752813 3.37789 0 2.60912 0 1.68097C6.64312e-09 1.23515 0.177098 0.80759 0.492335 0.492346C0.807572 0.177102 1.23513 0 1.68094 0C2.12675 0 2.5543 0.177102 2.86954 0.492346C3.18478 0.80759 3.36188 1.23515 3.36188 1.68097C3.36188 2.60912 2.60875 3.37789 1.68094 3.37789ZM13.9969 14H11.1006V9.4499C11.1006 8.3655 11.0787 6.97484 9.59156 6.97484C8.0825 6.97484 7.85125 8.15299 7.85125 9.37177V14H4.95188V4.65292H7.73562V5.92794H7.77625C8.16375 5.19355 9.11031 4.41854 10.5225 4.41854C13.46 4.41854 14 6.35295 14 8.86551V14H13.9969Z" fill="white" />
                </svg>
                <Link href="https://sg.linkedin.com/company/sixsense-pte-ltd" target="_blank" className="text-white text-[1rem] font-ibm-plex font-[400] leading-[150%]">
                  Sixsense
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactFormLeftPanel;
